<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 *ngIf="!user.isNewUser" class="t-widgetTitle">
      {{ "translate.users.editUser" | translate }}
      <span class="fw-regular">({{ user.userId }})</span>
    </h2>
    <h2 *ngIf="user.isNewUser" class="t-widgetTitle">
      {{ "translate.users.createUser" | translate }}
    </h2>

    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container">
  <div class="details-container">
    <section class="w-full t-row">
      <h4>{{ "translate.users.authDetails" | translate }}</h4>

      <div class="l-flex-column t-panel no-indent">
        <!--username-->
        <input-wrap
          label="{{ 'translate.general.username' | translate }}"
          [required]="true"
          [customValidation]="validateUsername()"
          [customValidationWarn]="usernameValidationStr | translate"
          cssClass="l-cell-spread"
        >
          <input
            type="email"
            [(ngModel)]="user.username"
            class="t-input t-input--colored"
            [disabled]="!user.isNewUser"
            (keyup)="autoCompleteUsername($event)"
          />
        </input-wrap>

        <!-- password-->
        <input-wrap
          label="{{ 'translate.general.password' | translate }}"
          [required]="true"
          [customValidation]="validatePassword()"
          [customValidationWarn]="
            'translate.users.passwordValidation' | translate
          "
          cssClass="l-cell-spread"
        >
          <input
            type="text"
            [(ngModel)]="user.password"
            class="t-input t-input--colored"
            [disabled]="readonly_user"
          />
        </input-wrap>
      </div>
    </section>

    <section class="w-full">
      <h4>{{ "translate.users.permissions" | translate }}</h4>
      <div class="l-flex-column t-panel no-indent">
        <!--role-->
        <input-wrap
          label="{{ 'translate.general.role' | translate }}"
          [required]="true"
          [readonly]="readonly_user"
          cssClass="l-cell-spread"
        >
          <p-select
            class="t-input--colored"
            [options]="roleList"
            [(ngModel)]="user.role"
            [placeholder]="'translate.general.choose' | translate"
            [optionLabel]="'label'"
            (onChange)="onRoleChange()"
            [filter]="true"
            [resetFilterOnHide]="true"
            [disabled]="readonly_user"
            appendTo="body"
          ></p-select>
        </input-wrap>

        <!--clinic-->
        <input-wrap
          *ngIf="displayClinic"
          label="{{ 'translate.general.clinic' | translate }}"
          [required]="clinicRequired"
          [readonly]="readonly_user"
          cssClass="l-cell-spread"
        >
          <p-select
            class="t-input--colored"
            [options]="clinicList"
            [(ngModel)]="user.clinic"
            [placeholder]="'translate.general.choose' | translate"
            [optionLabel]="'clinicDescr'"
            [dataKey]="'clinicId'"
            [filter]="true"
            [resetFilterOnHide]="true"
            [disabled]="readonly_user"
            appendTo="body"
            (onChange)="onClinicChanged()"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
          ></p-select>
          <clear-multi
            *ngIf="user.clinic && !readonly_user"
            (click)="user.clinic = null; onClinicChanged()"
          ></clear-multi>
        </input-wrap>

        <!--plant-->
        <input-wrap
          *ngIf="displayPlant"
          label="{{ 'translate.general.plant' | translate }}"
          [required]="true"
          [readonly]="readonly_user"
          cssClass="l-cell-spread"
        >
          <p-select
            class="t-input--colored"
            [options]="plantList"
            [(ngModel)]="user.plant"
            [placeholder]="'translate.general.choose' | translate"
            [optionLabel]="'label'"
            [filter]="true"
            [resetFilterOnHide]="true"
            [disabled]="readonly_user"
            appendTo="body"
          ></p-select>
        </input-wrap>

        <!--doctor-->
        <input-wrap
          *ngIf="displayDoctor"
          label="{{ 'translate.general.doctor' | translate }}"
          [required]="doctorRequired"
          [readonly]="readonly_user"
          cssClass="l-cell-spread"
        >
          <p-select
            class="t-input--colored"
            [options]="filteredDoctorList"
            [(ngModel)]="user.doctor"
            [placeholder]="'translate.general.choose' | translate"
            [optionLabel]="'label'"
            [filter]="true"
            [resetFilterOnHide]="true"
            [disabled]="readonly_user"
            appendTo="body"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
          ></p-select>
          <clear-multi
            *ngIf="user.doctor && !readonly_user"
            (click)="user.doctor = null"
          ></clear-multi>
        </input-wrap>
      </div>
    </section>
  </div>

  <div class="username-container">
    <section class="w-full t-row--med">
      <h4>{{ "translate.users.userDetails" | translate }}</h4>

      <div class="l-flex-column t-panel no-indent">
        <!--user descr -->
        <input-wrap
          label="{{ 'translate.general.userDescr' | translate }}"
          [required]="true"
          cssClass="l-cell-spread"
        >
          <input
            type="text"
            [(ngModel)]="user.userDescr"
            class="t-input t-input--colored"
            [disabled]="readonly_user"
          />
        </input-wrap>

        <!--phone-->
        <input-wrap
          label="{{ 'translate.general.phone' | translate }}"
          [required]="true"
          cssClass="l-cell-spread"
        >
          <input
            type="tel"
            [(ngModel)]="user.phone"
            class="t-input t-input--colored"
            [disabled]="readonly_user"
          />
        </input-wrap>
      </div>
    </section>

    <div
      *ngIf="user.activeSw"
      class="t-panel-cell t-buttonSet"
      [class.l-align-spaceBetween]="!user.isNewUser"
      [class.l-align-end]="user.isNewUser"
    >
      <button
        *ngIf="!user.isNewUser"
        [disabled]="saving"
        (click)="disableUserClicked()"
        class="t-button-outline c-c1"
      >
        {{ "translate.users.disableUser" | translate }}
      </button>

      <spinner *ngIf="saving"></spinner>

      <button
        [disabled]="!allowSubmit() || saving"
        (click)="updateUser()"
        class="t-button-outline"
      >
        {{ "translate.general.save" | translate }}
      </button>
    </div>

    <div *ngIf="!user.activeSw" role="alert" class="c-alert t-alert-warn">
      המשתמש אינו פעיל
    </div>
  </div>
</div>
